import {Http} from "@/core/service/http.init";
import {Room} from "@/core/api/room.api";
import {roomEventApi} from "@/core/api/room.event.api";

export class RoomBaseApiService {
    data = {
        client: null,
        roomData: null
    };

    constructor() {
        roomEventApi.addEventListener('roomDataInit', async e => {
            this.setRoomData(Room.getRoomData());
        }, { once: true })
    }

    request (status = { auth: true, serialize: true }) {
        const instance = Http.getHttpInstance(status);

        if(status.serialize === true){
            this.sReq = this.sReq || new SerializeRequest({instance});
            return this.sReq;
        }

        return instance;
    }

    setRoomData(roomData) {
        this.data.roomData = roomData;
        return this;
    }

    getRoomId() {
        return this.data.roomData && this.data.roomData.roomId;
    }

}

class SerializeRequest {
    constructor({instance}) {
        this.instance = instance;
        this.queue = [];

        const THIS = this;
        ['get', 'post', 'update', 'delete', 'put', 'patch'].forEach(method => {
            this[method] = function(){
                return THIS.request(() => {
                    return instance[method].apply(instance, arguments);
                })
            }
        })
    }

    async request(req){
        const queue = this.queue;
        const promise = new Promise((resolve, reject) => {
            queue.push({
                req, resolve, reject
            });

            if(queue.length === 1){
                let run = async (queue) => {
                    const job = queue[0];
                    if(!job) return;
                    return job.req()
                        .then(job.resolve)
                        .catch(job.reject)
                        .finally(() => {
                            queue.shift();
                            run(queue);
                        })
                }
                run(queue)
                    .catch(e => {
                        console.warn(e);
                    });
            }
        });

        return promise;
    }

}
